module.exports = __webpack_public_path__ + "img/custom-item1-2.17baffd.png";